/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuSelector_viewer = {
    readonly isSkyscraperAdEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_viewer">;
    readonly " $refType": "SbRespRefineMenuSelector_viewer";
};
export type SbRespRefineMenuSelector_viewer$data = SbRespRefineMenuSelector_viewer;
export type SbRespRefineMenuSelector_viewer$key = {
    readonly " $data"?: SbRespRefineMenuSelector_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuSelector_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSkyscraperAdEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'd3a47ebbc267d4afe1733afffd5946ac';
export default node;
